<template>
  <div class="menu">
    <div class="auto_1140 clearfix">
      <div class="fl">
        <ol v-if="lan === 0" @click="isShow = !isShow" :class="{olshow: isShow}">
          <span>您所在位置：{{currentName}}</span>
        </ol>
        <ol v-else-if="lan === 1" @click="isShow = !isShow" :class="{olshow: isShow}">
          <span>Location：{{currentEnName}}</span>
        </ol>
        <ul class="ul clearfix sub" v-if="lan === 0" :class="{show: isShow}">
          <li v-for="( item, index ) in navList" :key="index" :id='"m" + item.id'>
            <router-link :to="{name: item.requestTo, query: { columnId: item.parentId } }">{{item.name}}</router-link>
            <!-- <div class="sub-menu" v-if="item.id === 18">
              <dl>
                <dd v-for="( report, index1 ) in reportList" :key="index1"><a :href="report.content" target="_blank" rel="nofollow" class="dot">{{report.title}}</a></dd>
              </dl>
            </div> -->
            <!-- <div class="sub-menu" v-if="item.id === 46">
              <dl>
                <dd v-for="( doc, index1 ) in documentList" :key="index1"><a :href="doc.content" target="_blank" rel="nofollow" class="dot">{{doc.title}}</a></dd>
              </dl>
            </div> -->
          </li>
        </ul>
        <ul class="ul clearfix sub en" v-else-if="lan === 1" :class="{show: isShow}">
          <li v-for="( item, index ) in navList" :key="index" :id='"m" + item.id'>
            <router-link :to="{name: item.requestTo, query: { columnId: item.parentId } }">{{item.enName}}</router-link>
            <!-- <div class="sub-menu" v-if="item.id === 18">
              <dl>
                <dd v-for="( report, index1 ) in reportList" :key="index1"><a :href="report.content" target="_blank" rel="nofollow" class="dot">{{report.title}}</a></dd>
              </dl>
            </div>
            <div class="sub-menu" v-if="item.id === 46">
              <dl>
                <dd v-for="( doc, index1 ) in documentList" :key="index1"><a :href="doc.content" target="_blank" rel="nofollow" class="dot">{{doc.title}}</a></dd>
              </dl>
            </div> -->
          </li>
        </ul>
      </div>
      <div class="fr">
        <div class="location" v-if="lan === 0">
          <router-link :to="{ name: 'Home', query: { columnId: 38 } }">首页</router-link> · <router-link :to="{ name: firstMenu.requestTo, query: { columnId: firstMenu.id } }">{{firstMenu.name}}</router-link> · <span>{{currentName}}</span>
        </div>
        <div class="location en" v-else-if="lan === 1">
          <router-link :to="{ name: 'Home', query: { columnId: 38 } }">Home</router-link> · <router-link :to="{ name: firstMenu.requestTo, query: { columnId: firstMenu.id } }">{{firstMenu.enName}}</router-link> · <span>{{currentEnName}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      current: 0,
      firstMenu: [],
      currentName: '',
      currentEnName: '',
      navList: [],
      lan: this.$store.state.isEn,
      reportList: [],
      documentList: [],
      isShow: false,
    }
  },
  watch: {
    $route () {
      // this.init()
    },
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
      sessionStorage.removeItem('reportList')
      this.initReportList()
    },
    '$store.state.articleTypeId' () {
      this.articleTypeId = this.$store.state.articleTypeId
      this.init()
    }
  },
  mounted () {
    this.init()
    this.initReportList()
  },
  methods: {
    async init () {
      // 获取当前页的上级栏目名，以及上级栏目下的所有子栏目
      const id = parseInt(this.$route.query.columnId)
      let menuList = []
      if (localStorage.getItem('routeList') === null) {
        await this.$api.post('api/benefitArticleType/queryByParam', { current: 1, pageSize: 50 }, r => {
          r.data.forEach((item) => {
            let id
            if (item.parentId === 0) {
              menuList.push(item)
              id = item.id
              const children = []
              r.data.forEach((inner) => {
                if (inner.parentId === id) {
                  children.push(inner)
                }
              })
              menuList[menuList.length - 1].children = children
            }
          })
          localStorage.setItem('routeList', JSON.stringify(menuList))
          menuList.forEach((item) => {
            if (item.id === id) {
              this.firstMenu = item
              this.navList = item.children
            }
          })
          // 获取当前栏目名
          menuList.forEach((item) => {
            item.children.forEach((inner) => {
              if (inner.id === this.$store.state.articleTypeId || inner.id === parseInt(this.$route.query.articleTypeId)) {
                this.currentName = inner.name
                this.currentEnName = inner.enName
              }
            })
          })
        })
      } else {
        try {
          menuList = JSON.parse(localStorage.getItem('routeList'))
          menuList.forEach((item) => {
            if (item.id === id) {
              this.firstMenu = item
              this.navList = item.children
            }
          })
          // 获取当前栏目名
          menuList.forEach((item) => {
            item.children.forEach((inner) => {
              if (inner.id === this.$store.state.articleTypeId || inner.id === parseInt(this.$route.query.articleTypeId)) {
                this.currentName = inner.name
                this.currentEnName = inner.enName
              }
            })
          })
        } catch (err) {
          console.log(err)
        }
      }

    },
    initReportList () {
      // 使用sessionStorage存储报告列表数据
      if (sessionStorage.getItem('reportList') === null || sessionStorage.getItem('documentList') === null) {
        this.$api.post('api/benefitArticle/queryByParam', { articleTypeId: 18, current: 1, pageSize: 8, bLanguage: this.lan }, r => {
          if (r.total && r.data) {
            this.reportList = r.data
            sessionStorage.setItem('reportList', JSON.stringify(r.data))
          }
        })
        this.$api.post('api/benefitArticle/queryByParam', { articleTypeId: 46, current: 1, pageSize: 8, bLanguage: this.lan }, r => {
          if (r.total && r.data) {
            this.documentList = r.data
            sessionStorage.setItem('documentList', JSON.stringify(r.data))
          }
        })
      } else {
        try {
          this.reportList = JSON.parse(sessionStorage.getItem('reportList'))
          this.documentList = JSON.parse(sessionStorage.getItem('documentList'))
        } catch (e) {
          console.log(e)
        }
      }
    }
  }
}
</script>
<style scoped>
.menu{width: 100%; line-height: 100px; height: 100px; background: #fff; border-radius: 40px 0; box-shadow: 0px 8px 15px 2px rgba(0, 0, 0, 0.1); transform: translateY(-55px); z-index: 100; position: relative;}
.menu .auto_1140{max-width: 1200px;}
.menu .fl{float: left; width: 65%; z-index: 100; position: relative;}
.menu .fr{float: right; width: 35%; text-align: right;}
.menu ol{display: none;}
.menu ol a{color: #333;}
.menu .sub li{float: left; margin-right: 6.5%; line-height: 97px; position: relative; z-index: 100;}
.menu .sub li:last-child{margin-right: 0;}
.menu .sub li a{box-sizing: border-box; display: block; color: #333; font-size: 18px; cursor: pointer; font-weight: lighter;}
.menu .sub li a.router-link-active{color: #e4007f; border-bottom: 3px solid #e4007f;}
.menu .sub.en li{margin-right: 2%;}
.menu .sub.en li a{font-size: 15px;}
.menu .location a{padding: 0 10px; font-size: 16px; color: #999; font-weight: lighter;}
.menu .location.en a{padding: 5px;}
.menu .location a:first-child{background: url(../assets/home.png)no-repeat left center; padding-left: 25px;}
.menu .location span{font-size: 16px; color: #999; font-weight: lighter; padding-left: 10px; color: #e4007f}

.menu .sub-menu{position: absolute; width: 200%; height: auto; left: 50%; top: 100%; transform: translateX(-50%); background-color: rgba(228,0,127,0.7); display: none; z-index: 10; border-radius: 5px;}
.menu .sub-menu::before{width: 0; height: 0; border: 8px solid transparent; border-bottom-color: rgba(228,0,127,0.7); position: absolute; top: 0; left: 50%; transform: translate(-50%, -99%);}
.menu .sub-menu dd{margin-inline-start: 0; line-height: 45px; text-align: center; transition: all .2s ease-in-out; border-bottom: 1px solid rgba(255, 255, 255, 0.2); padding: 0 3%;}
.menu .sub-menu a{color: #fff!important; font-size: 16px!important;}
.menu li:hover .sub-menu{display: block;}
.menu li:hover .sub-menu::before{content: '';}
.menu .sub-menu dd:hover{background-color: rgba(255, 255, 255, 0.2);}
@media(max-width: 1600px){
  .menu .auto_1140{max-width: 1210px;}
}
@media(max-width: 1200px){
  .menu .location{display: none;}
  .menu .fl{width: 100%;}
  .menu .sub li{margin-right: 4%;}
}
@media(max-width: 1024px){
  .menu{height: auto; line-height: 80px; transform: translateY(-40px); overflow: hidden;}
  .menu .fl{width: 100%;}
  .menu ol{display: block; margin: 0; padding: 0; cursor: pointer; background: url(../assets/a_down.png)no-repeat right center;}
  .menu .sub{background: rgba(228,0,127,0.1); padding: 0 2%; height: 0; margin: 0 -2%; transition: all .3s; overflow: hidden;}
  /* .menu:hover .sub{height: auto;}
  .menu:hover ol{background: url(../assets/a_up.png)no-repeat right center;} */
  .menu ol.olshow{background: url(../assets/a_up.png)no-repeat right center;}
  .menu .sub.show{height: auto;}
  .menu .sub li{line-height: 50px; float: none; margin: 0;}
  .menu .sub li.aon a{border: none;}
  .menu .sub-menu{position: initial; width: 100%; transform: translate(0,0); max-width: none; border-radius: 0;}
  .menu .sub-menu::before{content: none!important;}
  .menu .sub-menu dd{text-align: left;}
}
@media(max-width: 640px){
  .menu{border-radius: 30px 0; transform: translateY(-30px);}
  .menu ol{line-height: 60px;}
}
</style>
